module.exports = __webpack_public_path__ + "img/revocation.667a0126.svg";